export enum PreferenceType {
    None = 0,
    Preferred = 1,
    Avoid = 2
}
